
export const setExperiences = (state, experiences) => {
    state.experiences = experiences
    state.loading = false
}

export const setCurrentExperience = (state, point) => {
    state.currentExperience = point
    state.loading = false
}

export const setLoading = (state, loading) => {
    state.loading = loading
}
